









































































































































import { defineComponent, ref, watch, onMounted, reactive, computed, PropType } from '@vue/composition-api';
import ChannelTree from '@/data/ChannelTree';
import UiChannelTree from '@/data/UiChannelTree';
import UiChannels from '@/data/UiChannels';
import VideoService from '@/services/videos/VideoService';
import VideoServiceRawMgnl  from '@/services/videos/VideoServiceRawMgnl';
import EnvService from '@/services/environment/EnvService';
import VideosFetchConfig from '@/services/videos/VideosFetchConfig';
import VideosResultConfig from '@/services/videos/VideosResultConfig';
import Videos from '@/data/Videos';
import Video from '@/data/Video';
import BreadCrumb from '@/data/BreadCrumb';
import UiActiveVideo from '@/data/UiActiveVideo';
import SocialShareInfo from '@/data/SocialShareInfo';
import ContextInfo from '@/data/settings/ContextInfo';
import BreadCrumbsHelper from '@/utils/BreadCrumbsHelper';
import VideoSortFactory from '@/utils/VideoSortFactory';
import Pagination from '@/data/Pagination';
import useVideoListLayout from '@/composables/useVideoListLayout';
import useMainLayout from '@/composables/useMainLayout';
import SharedState from '@/data/SharedState';
import NavigationTree from '@/data/NavigationTree';
import { getName as getRegionName } from '@/utils/Region';

import VideoContainer from '@/components/VideoContainer.vue';
import VideoList from '@/components/VideoList.vue';
import SortSelect from '@/components/SortSelect.vue';
import MainLayout from '@/components/MainLayout.vue';
import RelatedVideos from '@/components/RelatedVideos.vue';
import PaginationC from '@/components/PaginationC.vue';
import BreadCrumbs from '@/components/BreadCrumbsC.vue';
import VideoCount from '@/components/VideoCount.vue';
import ChannelNavTopLevel from '@/components/ChannelNavTopLevel.vue';
import SearchInput from '@/components/SearchInput.vue';
import ShowMore from '@/components/ShowMore.vue';
import Logger from '@/utils/Logger';
import ChannelMapper from '@/data/mappers/ChannelMapper';
import { LayoutType } from '@/data/layout/MainLayoutInfo';

export default defineComponent({
  components: {
    VideoList,
    VideoContainer,
    MainLayout,
    RelatedVideos,
    BreadCrumbs,
    SortSelect,
    PaginationC,
    VideoCount,
    ChannelNavTopLevel,
    SearchInput,
    ShowMore
  },
  name: 'CorpTube',
  props: {
    contextInfo: {
      type: Object as PropType<ContextInfo>,
      default: new ContextInfo('')
    },
    activeVideoId: {
      type: String,
      default: undefined
    },
    activeChannelId: {
      type: Number,
      default: undefined
    }
  },
  setup(props, context) {

    let videoService: VideoService | undefined = undefined;
    let playerId = '0';
    const usePagination = props.contextInfo.videoListUsePagination;

    const baseElem = ref<HTMLDivElement|null>(null);
    const relatedVideosLoadedOnce = ref(false);
    const isInitialSearchView = ref(false);

    const videoListRowCount = ref<number|undefined>(undefined);
    const { videoListLayout, getVideoListLayout } = useVideoListLayout(usePagination, videoListRowCount, baseElem);
    const { layoutType, scrolledToBottom, scrollIntoView } = useMainLayout(baseElem);
    const channelTree = ref(new ChannelTree(0));
    const uiChannels = reactive(new UiChannels(new UiChannelTree(0, 0, 0, undefined)));
    const activeChannelVideos = reactive(new Videos(0));
    const allowedChannels = ref<Array<number>>([]);
    const currentSortType = ref('std');
    const homeVideos = reactive(new Videos(0));
    const searchVideos = reactive(new Videos(0));
    const uiActiveVideo = reactive(new UiActiveVideo());
    const uiUseMiPlayer = ref(EnvService.getEnvVar('VUE_APP_USE_MOVINGIMAGE_PLAYER') === 'true');
    const menuIsOpen = ref(false);
    const videoContainerHeight = ref(0);
    const breadCrumbs = ref<Array<BreadCrumb>>([]);
    const pagination = reactive(new Pagination());
    const remoteSortSupported = ref(false);
    const searchIsOpen = ref(false);
    const loadingVideos = ref(false);
    const showSocialShareButtons = ref(false);
    const socialShareInfo = ref<SocialShareInfo>(new SocialShareInfo('', ''));
    const activeVideoLoadError = ref(false);
    const activeVideoLoadErrorVideoId = ref<string|undefined>(undefined);
    const videoListLoadError = ref(false);
    const baseChannelId = ref<number|undefined>(undefined);
    const baseChannelName = ref<string|undefined>(undefined);
    const loadingRelatedVideos = ref(false);
    const relatedVideosLoadError = ref(false);

    const openTree = reactive({
      tree: uiChannels.uiChannelTree.getOpenTree() as UiChannelTree
    });

    const isReady = () => {
      if(!videoService) return false;
      return true;
    };

    const updateSocialShareInfo = () => {
      if(!uiActiveVideo.video) return;

      socialShareInfo.value = new SocialShareInfo(
        `${props.contextInfo.requestUrl}#${uiActiveVideo.video.id}`,
        uiActiveVideo.video.title ? uiActiveVideo.video.title : '',
        props.contextInfo.requestUrl,
        props.contextInfo.getCountryCode());
    };

    const fetchActiveVideoMetaData = async (videoId: string) => {
      if(!videoService || !isReady()) return;
      if(!uiActiveVideo.video || uiActiveVideo.video.id !== videoId) {
        uiActiveVideo.video = await videoService.getVideoMetaData(videoId);
      }
    }

    const fetchActiveVideo = async (videoId: string) => {
      if(!videoService || !isReady() || !uiActiveVideo.video) return;

      try {
        relatedVideosLoadError.value = false;
        window.location.hash = videoId;
        if(!uiUseMiPlayer) {
          uiActiveVideo.videoData = await videoService.getVideoData(videoId);
        }
        try {
          loadingRelatedVideos.value = true;
          uiActiveVideo.relatedVideos = await videoService.getRelatedVideos(
            videoId, allowedChannels.value, baseChannelId.value, baseChannelName.value, props.contextInfo.locale);
        }
        catch(error) {
          relatedVideosLoadError.value = true;
        }
        finally {
          loadingRelatedVideos.value = false;
          relatedVideosLoadedOnce.value = true;
        }
      }
      catch(error) {
        activeVideoLoadError.value = true;
        activeVideoLoadErrorVideoId.value = videoId;
        loadingRelatedVideos.value = false;
        throw error;
      }
      activeVideoLoadError.value = false;
      activeVideoLoadErrorVideoId.value = '';

      updateSocialShareInfo();
    };

    const fetchAllVideoData = async (waitUntilFullyDone: boolean, videoId?: string) => {
      if(!videoId) return;

      try {
        await fetchActiveVideoMetaData(videoId);

        if(waitUntilFullyDone) await fetchActiveVideo(videoId);
        else {
          fetchActiveVideo(videoId).catch(error => {
            Logger.warn(`Failed to fetch video data for video with id ${videoId}, ${error}.`);
          });
        }
      }
      catch(error) {
        activeVideoLoadError.value = true;
        activeVideoLoadErrorVideoId.value = videoId;
        Logger.warn(`Failed to fetch video data or meta data for video with id ${videoId}, ${error}.`);
      }
    }

    function paginationReset() {
      pagination.reset();
      videoListLayout.value.resetRowCount();
      pagination.limit = videoListLayout.value.maxItemCount;
    }

    function initFetchVideos(videos: Videos): boolean {
      if(videos.total === 0) {
        paginationReset();
      }
      else {
        const lastVideoIndex = Math.min(videos.total - 1, pagination.offset + pagination.limit - 1);
        if(videos.videos[lastVideoIndex]) {
          return false;
        }
      }
      return true;
    }

    const sortVideos = (videos: Videos) => {

      let channelName = baseChannelName.value;
      let calcOwnPrio = false;
      if(uiChannels.activeChannelId) {
        channelName = uiChannels.uiChannelTree.getNavTree(uiChannels.activeChannelId).name;
        calcOwnPrio = uiChannels.activeChannelId !== undefined
      }

      const videoSort = VideoSortFactory.getVideoSort(currentSortType.value, props.contextInfo.region, channelName);
      videos.videos = videoSort.sort(videos.videos as Array<Video>, calcOwnPrio);
    }

    function calcMinOffsetForFetch(videos: Videos): number {
      for(let offset = 0; offset < videos.total; ++offset) {
        if(!videos.videos[offset]) return offset;
      }
      return videos.total;
    }

    function getFetchConfig(videos: Videos): VideosFetchConfig | undefined {
      
      if(videos.total === 0) {
        paginationReset();
      }
      
      let minOffset = calcMinOffsetForFetch(videos);
      if(minOffset < pagination.offset) minOffset = pagination.offset;

      if(minOffset >= videos.total && videos.total > 0) {
        return undefined;
      }
      const endIndex = pagination.offset + pagination.limit;
      if(videos.total > endIndex - 1 && videos.videos[endIndex - 1]) {
        return undefined;
      }
      const limit = endIndex - minOffset;

      const videosFetchConfig = new VideosFetchConfig();
      videosFetchConfig.allowedChannelIds = allowedChannels.value;
      videosFetchConfig.listOffset = minOffset;
      videosFetchConfig.maxCount = limit;
      return videosFetchConfig;
    }

    async function fetchHomeVideos(setActiveVideo?: boolean) {

      if(!videoService || !isReady()) return;
      if(setActiveVideo === undefined) setActiveVideo = true;

      videoListLoadError.value = false;
      const isFirstLoad = homeVideos.total === 0;
      if(!initFetchVideos(homeVideos as Videos)) {
        return; // videos are already loaded;
      }
      const videosFetchConfig = getFetchConfig(homeVideos as Videos);
      if(!videosFetchConfig) {
        return; // videos are already loaded;
      }

      try {

        loadingVideos.value = true;

        if(!baseChannelId.value || !baseChannelName.value) {
          throw new Error("fetchHomeVideos: No base channel set.")
        }

        homeVideos.applyFrom(await videoService.getVideos(
          videosFetchConfig, new VideosResultConfig(),
          currentSortType.value, baseChannelId.value, baseChannelName.value, props.contextInfo.locale));
        pagination.total = homeVideos.total;

        videoListLoadError.value = false;
      }
      catch(error) {
        videoListLoadError.value = true;
        Logger.warn(`fetchHomeVideos: Failed to load videos, ${error}.`);
      }
      finally {
        loadingVideos.value = false;
      }

      if(!remoteSortSupported.value) {
        sortVideos(homeVideos as Videos);
      }

      if(setActiveVideo && (!uiActiveVideo.video || isFirstLoad) && homeVideos.videos.length > 0 && homeVideos.videos[0]) {
        uiActiveVideo.video = homeVideos.videos[0];
        fetchActiveVideo(uiActiveVideo.video.id);
      }
    };

    const onVideoListSort = (sortTypeKey?: string) => {

      if(sortTypeKey) {
        if(sortTypeKey === currentSortType.value) {
          return;
        }
        currentSortType.value = sortTypeKey;
      }

      if(uiChannels.activeChannelId) {
        sortVideos(activeChannelVideos as Videos);
      }
      else if(searchVideos.videos.length > 0) {
        sortVideos(searchVideos as Videos);
      }
      else if(!remoteSortSupported.value) {
        sortVideos(homeVideos as Videos);
      }
      else {
        homeVideos.clearVideos();
        fetchHomeVideos();
      }
    };

    const getBreadCrumbsHelper = () => {
      return new BreadCrumbsHelper(
        SharedState.getText(context, 'corptube.home'),
        SharedState.getText(context, 'corptube.search'));
    }

    const getHomeBreadCrumbs = (): Array<BreadCrumb> => {
      return getBreadCrumbsHelper().getHomeBreadCrumbs();
    }

    const getSearchBreadCrumbs = (): Array<BreadCrumb> => {
      return getBreadCrumbsHelper().getSearchBreadCrumbs();
    }

    const getBreadCrumbs = (navTree: NavigationTree): Array<BreadCrumb> => {
      return getBreadCrumbsHelper().getBreadCrumbs(navTree);
    };

    const init = async () => {

      if(EnvService.getEnvVar('VUE_APP_STANDALONE') === 'true') {
        //videoService = new VideoService(new VideoServiceRaw(new TokenService()));
        videoService = new VideoService(new VideoServiceRawMgnl(props.contextInfo));
      }
      else {
        videoService = new VideoService(new VideoServiceRawMgnl(props.contextInfo));
      }
      remoteSortSupported.value = videoService.hasRemoteSort();
      await videoService.init();

      if(uiUseMiPlayer) {
        playerId = videoService.getStoredPlayer().id;
      }
    };

    const fetchChannelTree = async () => {
      await init();
      if(!videoService || !isReady()) return;

      let newChannelTree: ChannelTree | undefined = undefined;
      let channelsInfoDefinition: string | undefined = undefined;

      try {
        const newChannelTreePromise = videoService.getChannels();
        const channelsInfoDefinitionPromise = videoService.getChannelsInfoDefinition(
          props.contextInfo.channelsInfoWorkspace, props.contextInfo.channelsInfoJcrPropertyPath);
        newChannelTree = await newChannelTreePromise;
        channelsInfoDefinition = await channelsInfoDefinitionPromise;

        if(EnvService.hasEnvVar('VUE_APP_SUB_CHANNEL_NAME')) {

          // For debugging purposes.

          const channelName = EnvService.getEnvVar('VUE_APP_SUB_CHANNEL_NAME');
          Logger.info(`Setting ${channelName} as base channel.`);
          baseChannelId.value = newChannelTree.getChannelIdByName(channelName);
          baseChannelName.value = channelName;
          if(!baseChannelId.value) {
            throw new Error(`No channel found with name ${channelName}.`);
          }
        }
        else {

          if(props.contextInfo.region === undefined) {
            throw new Error(`Current region not defined. Please check your site configuration.`);
          }

          const regionName = getRegionName(props.contextInfo.region) as string;
          baseChannelId.value = newChannelTree.getChannelIdByName(regionName);
          baseChannelName.value = regionName;

          if(!baseChannelId.value) {
            throw new Error(`Id of channel containing videos for region ${regionName} not found.`);
          }
        }

        const subTree = newChannelTree.cloneSubTree(baseChannelId.value);
        if(!subTree) {
          throw new Error(
            `Error cloning subTree channels with base channel ` +
            `id ${baseChannelId.value} and name ${baseChannelName.value}.`);
        }

        if(props.contextInfo.useLocalizedChannelNames || !props.contextInfo.isAuthoring) {
          subTree.initLocalizedNames(keys => SharedState.getChannelText(context, keys));
        }
        const channelMapper = new ChannelMapper(props.contextInfo.locale);
        if(EnvService.hasEnvVar('VUE_APP_LOG_CHANNELS') &&
            EnvService.getEnvVar('VUE_APP_LOG_CHANNELS') === 'true') {

          Logger.info(channelMapper.getChannelsDefinitionDefault(subTree));
        }

        channelMapper.setChannelsInfo(channelsInfoDefinition);
        allowedChannels.value = channelMapper.getAllowedChannels(subTree);
        channelMapper.filter(subTree);
        channelMapper.sort(subTree, channelMapper.channelCompareFunc.bind(channelMapper));

        channelTree.value = subTree;

        uiChannels.uiChannelTree.initFrom(subTree, context);
        uiChannels.uiChannelTree.open();
      }
      catch(error) {
        Logger.warn(`Failed to fetch channels. ${error}`);

        // if(EnvService.getEnvVar('VUE_APP_ALLOW_ALL_CHANNELS') === 'true' && newChannelTree) {
        //   Logger.info(`Using all channels as a fallback.`);
        //   channelTree.value = newChannelTree;
        //   uiChannels.uiChannelTree.initFrom(newChannelTree, context);
        //   uiChannels.uiChannelTree.open();
        // }
      }
    };

    const fetchActiveChannelVideos = async (setActiveVideo?: boolean) => {
      if(!videoService || !isReady()) return;

      if(!initFetchVideos(activeChannelVideos as Videos)) {
        return; // videos are already loaded;
      }

      const videosFetchConfig = new VideosFetchConfig();
      videosFetchConfig.allowedChannelIds = allowedChannels.value;

      if(uiChannels.activeChannelId) {
        videosFetchConfig.channelIds.push(uiChannels.activeChannelId);
      }
      try {

        loadingVideos.value = true;

        activeChannelVideos.applyFrom(await videoService.getVideos(
          videosFetchConfig, new VideosResultConfig(),
          undefined, undefined, undefined, props.contextInfo.locale));

        videoListLoadError.value = false;
      }
      catch(error) {
        videoListLoadError.value = true;
        Logger.warn(
          `fetchActiveChannelVideos: Failed to load videos for ` +
          `channel with id ${uiChannels.activeChannelId}, ${error}.`);
      }
      finally {
        loadingVideos.value = false;
      }
      pagination.total = activeChannelVideos.total;
      sortVideos(activeChannelVideos as Videos);

      if(setActiveVideo && activeChannelVideos.videos.length > 0) {
        uiActiveVideo.video = activeChannelVideos.videos[0] as Video;
        fetchActiveVideo(uiActiveVideo.video.id);
      }
    };

    const clearAllVideos = (): void => {
      isInitialSearchView.value = false;
      homeVideos.clear();
      activeChannelVideos.clear();
      searchVideos.clear();
    }

    const onChannelTreeClicked = (id: number) => {

      uiChannels.uiChannelTree.toggle(id);
      openTree.tree = uiChannels.uiChannelTree.getOpenTree() as UiChannelTree;
    };

    const onChannelTreeOpen = (id: number) => {

      uiChannels.uiChannelTree.openById(id);
      openTree.tree = uiChannels.uiChannelTree.getOpenTree() as UiChannelTree;
    }


    const onChannelSelected = (id: number) => {

      if(uiChannels.activeChannelId !== id) {

        searchVideos.clear();

        if(id === BreadCrumbsHelper.homePseudoChannelId) {
          uiChannels.activeChannelId = undefined;
          clearAllVideos();
          fetchHomeVideos(true);
          breadCrumbs.value = getHomeBreadCrumbs();
          videoListRowCount.value = undefined;
          uiChannels.uiChannelTree.deselectAll();
        }
        else {
          clearAllVideos();
          pagination.reset();
          uiChannels.uiChannelTree.selectUniqueIf(id);
          uiChannels.activeChannelId = id;
          paginationReset();
          fetchActiveChannelVideos(true);
          menuIsOpen.value = false;
          uiChannels.uiChannelTree.closeAllChildren();
          breadCrumbs.value = getBreadCrumbs(uiChannels.uiChannelTree.getNavTree(id));
          videoListRowCount.value = undefined;
        }
      }
    };

    const onVideoListSelected = (video: Video) => {
      uiActiveVideo.video = video;
      isInitialSearchView.value = false;
      fetchActiveVideo(video.id);
      if(layoutType.value === LayoutType.SMALL || !usePagination) {
        scrollIntoView();
      }
    };

    const onMenuClick = (buttonState: string) => {

      switch(buttonState) {
        case 'open': menuIsOpen.value = true; break;
        case 'close': menuIsOpen.value = false; break;
        default:
          uiChannels.uiChannelTree.closeOneLevel();
      }
    }

    const onVideoContainerHeightChange = (height: number) => {
      videoContainerHeight.value = height;
    };

    const onPaginationChange = (offset: number) => {

      pagination.offset = offset;
      if(uiChannels.activeChannelId !== undefined) {
        fetchActiveChannelVideos();
      }
      else if(searchVideos.videos.length === 0) {
        fetchHomeVideos();
      }
    };

    const allVideos = computed(() => {
      if(uiChannels.activeChannelId) {
        return activeChannelVideos;
      }
      else if(homeVideos.videos.length > 0) {
        return homeVideos;
      }
      return searchVideos;

    });

    const hasVideos = computed(() => {
      return uiChannels.activeChannelId ||
        homeVideos.total > 0 ||
        searchVideos.videos.length > 0
    });

    const showSortSelect = computed(() => {
      return (uiChannels.activeChannelId && activeChannelVideos.total > 1) ||
        (homeVideos.total > 1 && remoteSortSupported) ||
        searchVideos.videos.length > 1;
    });

    const minHeightVideo = computed(() => {
      if(layoutType.value == LayoutType.SMALL) {
        return 100;
      }
      return 0;
    });

    const videoContainerAttrs = computed(() => {

      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
      const videoAttrs: any = {};

      if(!uiUseMiPlayer.value) {
        videoAttrs.sourceUrl = uiActiveVideo.videoData ? uiActiveVideo.videoData.url : undefined;
        videoAttrs.posterUrl = uiActiveVideo.video?.posterUrl;
      }
      else {
        videoAttrs.videoId = uiActiveVideo.video?.id;
        videoAttrs.playerId = playerId;
      }

      const dataAddedMs = uiActiveVideo.video?.publicationDate
        ? uiActiveVideo.video.publicationDate
        : uiActiveVideo.video?.createdDate;

      videoAttrs.title = uiActiveVideo.video?.title;
      videoAttrs.views = uiActiveVideo.video?.views;
      videoAttrs.dateAddedMs = dataAddedMs;
      videoAttrs.description = uiActiveVideo.video?.desc;
      videoAttrs.showSocialShareButtons = showSocialShareButtons.value;
      return videoAttrs;
    });

    const currentVideoCount = computed(() => {
      if(uiChannels.activeChannelId !== undefined) {
        return activeChannelVideos.total;
      }
      else if(isInitialSearchView.value || searchVideos.total !== 0) {
        return searchVideos.total;
      }
      else if(homeVideos.total !== 0) {
        return homeVideos.total;
      }
      return 0;
    });

    const isSmallLayout = computed(() => {
      return layoutType.value === LayoutType.SMALL;
    });

    const onMainLayoutClicked = () => {
      uiChannels.uiChannelTree.close();
      menuIsOpen.value = false;
      showSocialShareButtons.value = false;
    };

    const onSearchOpen = () => {
      searchIsOpen.value = true;
      menuIsOpen.value = false;
    };
    const onSearchClose = () => {
      searchIsOpen.value = false;
    };
    const onSearch = async (searchTerms: Array<string>) => {
      if(!videoService || !isReady()) return;
      clearAllVideos();
      paginationReset();
      uiChannels.activeChannelId = undefined;
      uiChannels.uiChannelTree.deselectAll();
      isInitialSearchView.value = true;
      breadCrumbs.value = getSearchBreadCrumbs();
      try {
        loadingVideos.value = true;
        searchVideos.applyFrom(await videoService.searchVideos(searchTerms, allowedChannels.value,
          baseChannelId.value, baseChannelName.value, props.contextInfo.locale));
        pagination.total = searchVideos.total;
      }
      catch(error) {
        videoListLoadError.value = true;
      }
      finally {
        loadingVideos.value = false;
      }
    };

    const onShowMore = (additionalRows?: number) => {
      if(!additionalRows) additionalRows = 3;
      const incCount = videoListLayout.value.columnCount * additionalRows;

      pagination.limit += incCount;
      videoListRowCount.value = videoListLayout.value.rowCount + additionalRows;

      if(uiChannels.activeChannelId !== undefined) {
        fetchActiveChannelVideos();
      }
      else if(searchVideos.videos.length === 0) {
        fetchHomeVideos();
      }
    };

    const onShareVideo = () => {
      showSocialShareButtons.value = true;
    }

    const hasMoreVideos = computed(() => {
      return pagination.offset + pagination.limit < pagination.total;
    });

    const videoListRowCountC = computed(() => {
      return videoListRowCount;
    });

    watch(
      () => layoutType.value,
      (newVal) => {
        videoListRowCount.value = undefined;
        if(newVal === LayoutType.SMALL || !usePagination) {
          pagination.limit = videoListLayout.value.maxItemCount;
          pagination.offset = 0;
          onPaginationChange(pagination.offset);
        }
      }
    );

    watch(
      () => videoListLayout.value.maxItemCount,
      (newValue) => {
        if(usePagination) {
          pagination.limit = newValue;
          onPaginationChange(pagination.offset);
        }
      }
    );

    watch(
      () => scrolledToBottom.value,
      (newVal) => {
        if(newVal === true && hasMoreVideos.value && !usePagination) {
          onShowMore();
        }
      }
    );

    onMounted(async () => {

      await fetchChannelTree();
      pagination.limit = videoListLayout.value.maxItemCount;
      await fetchHomeVideos(props.activeVideoId === undefined);
      if(props.activeVideoId) {
        await fetchAllVideoData(false, props.activeVideoId);
      }

      breadCrumbs.value = getHomeBreadCrumbs();
    });

    return {
      channelTree,
      activeChannelVideos,
      uiChannels,
      onChannelTreeClicked,
      onChannelSelected,
      onVideoListSelected,
      uiActiveVideo,
      videoContainerAttrs,
      menuIsOpen,
      onMenuClick,
      onVideoContainerHeightChange,
      videoContainerHeight,
      breadCrumbs,
      onVideoListSort,
      homeVideos,
      currentSortType,
      pagination,
      onPaginationChange,
      remoteSortSupported,
      currentVideoCount,
      openTree,
      onMainLayoutClicked,
      isSmallLayout,
      onChannelTreeOpen,
      searchIsOpen,
      onSearchOpen,
      onSearchClose,
      onSearch,
      onShowMore,
      hasMoreVideos,
      videoListRowCount,
      videoListRowCountC,
      loadingVideos,
      onShareVideo,
      showSocialShareButtons,
      socialShareInfo,
      activeVideoLoadError,
      activeVideoLoadErrorVideoId,
      videoListLoadError,
      loadingRelatedVideos,
      minHeightVideo,
      hasVideos,
      allVideos,
      showSortSelect,
      relatedVideosLoadError,
      baseElem,
      relatedVideosLoadedOnce,
      searchVideos,
      isInitialSearchView,
      getVideoListLayout,
      usePagination
    }
  }
})
